module.exports = __webpack_public_path__ + "static/img/projectcase.ece4a28c.png";